import React from "react";
import PropTypes from "prop-types";
import { createNewAdmin } from "../../../action/admin/getActiveLoginUserList";
import { frontEndLogs } from "../../../action/logs/frontEndLogs";
import { analyticsClickEvent } from "../../../action/firebaseAnalytics/firebaseAnalytics";
export default class CreateAdminModal extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			formData: {
				firstName: "",
				lastName: "",
				email: "",
				mobileNumber: ""
			},
			errors: {
				firstName: "",
				lastName: "",
				email: "",
				mobileNumber: ""
			},
		};
	}

	validateAdminName = (value, fieldName) => {
		let error = "";
		if (value.endsWith("-") || value.endsWith("'")) {
			value = value.slice(0, -1);
		}
		if (value.length === 0) {
			error = "This is required";
		}
		else if (value.length < 2 || value.length > 30) {
			error = `Enter ${fieldName} between 2 and 30 characters`;
		}
		return error;
	};

	validateAdminFirstName = (value) => {
		let error = this.validateAdminName(value, "First Name");
		const titles = [
			"mr", "ms", "mrs", "miss", "dr", "prof", "rev", "hon",
			"sir", "dame", "lord", "lady", "capt", "major", "col",
			"gen", "lt", "sgt", "fr", "rabbi", "imam",
			"bishop", "cardinal", "baron", "baroness",
			"viscount", "viscountess", "marquess", "marchioness",
			"earl", "countess", "duchess", "prince", "king"
		];
		const firstNameWord = value.trim().split(/['-]/)[0].toLowerCase();
		if (titles.includes(firstNameWord)) {
			error = "Titles (e.g. Mr, Ms, Dr, etc.) are not allowed";
		}
		this.setState((prevState) => ({
			errors: {
				...prevState.errors,
				firstName: error
			}
		}));
	}

	validateAdminLastName = (value) => {
		const error = this.validateAdminName(value, "last name");
		this.setState(prevState => ({
			errors: {
				...prevState.errors,
				lastName: error
			}
		}));
	}

	validateAdminEmail = (value) => {
		let error = "";
		if (value.length === 0) {
			error = "This is required";
		} else if (value.length > 50) {
			error = "Email should not exceed 50 characters";
		} else {
			const emailRegex = /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@[a-z0-9-]+(\.[a-z]{2,})+$/i;
			if (!emailRegex.test(value)) {
				error = "Please enter a valid email";
			}
		}
		this.setState((prevState) => ({
			errors: {
				...prevState.errors,
				email: error
			}
		}));
	};

	validateAdminMobileNumber = (value) => {
		let error = "";
		if (value.length === 0) {
			error = "This is required";
		} else if (!/^07\d{9}$/.test(value)) {
			error = "Enter a valid UK mobile number";
		}
		this.setState((prevState) => ({
			errors: {
				...prevState.errors,
				mobileNumber: error
			}
		}));
	};

	validateField = (name, value) => {
		switch (name) {
			case "firstName":
				return this.validateAdminFirstName(value);

			case "lastName":
				return this.validateAdminLastName(value);

			case "email":
				return this.validateAdminEmail(value);

			case "mobileNumber":
				return this.validateAdminMobileNumber(value);

			default:
				return;
		}
	}

	handleInputChange = (event) => {
		const { name, value } = event.target;
		let updatedValue = value;
		if (name === "firstName" || name === "lastName") {
			updatedValue = value.replaceAll(/[^A-Za-z'-]/g, "");
			if (updatedValue.startsWith("'") || updatedValue.startsWith("-")) {
				return;
			}
			if ((updatedValue.match(/'/g) || []).length > 1) {
				return;
			}
			if ((updatedValue.match(/-/g) || []).length > 1) {
				return;
			}
		} else if (name === "email") {
			updatedValue = value.replaceAll(/\s/g, "");
		} else if (name === "mobileNumber") {
			updatedValue = value.replaceAll(/\D/g, "");
			if (updatedValue.length > 11) {
				return;
			}
		}
		this.setState((prevState) => ({
			formData: {
				...prevState.formData,
				[name]: updatedValue
			}
		}));
		this.validateField(name, updatedValue);
	}

	handleBlur = (event) => {
		const { name } = event.target;
		let value = this.state.formData[name];
		if (value.endsWith("'") || value.endsWith("-")) {
			value = value.slice(0, -1);
		}
		this.setState(prevState => ({
			formData: {
				...prevState.formData,
				[name]: value
			}
		}));
		this.validateField(name, value);
	}

	isCreateAdminFormValid = () => {
		const { formData, errors } = this.state;
		return (
			formData.firstName !== "" && formData.lastName !== "" && formData.email !== "" && formData.mobileNumber !== "" &&
			errors.firstName === "" && errors.lastName === "" && errors.email === "" && errors.mobileNumber === ""
		);
	};

	resetForm = () => {
		this.setState({
			formData: { firstName: "", lastName: "", email: "", mobileNumber: "" },
			errors: { firstName: "", lastName: "", email: "", mobileNumber: "" }
		});
	};

	handleCloseModal = () => {
		this.resetForm();
		this.props.closeCreateAdminModal();
	};

	handleCreateAdmin = async () => {
		const { formData } = this.state;
		const payload = {
			firstName: formData.firstName,
			lastName: formData.lastName,
			email: formData.email.toLowerCase(),
			mobileNumber: formData.mobileNumber
		};
		analyticsClickEvent('admin_create_button_clicked', '');
		frontEndLogs('admin_create_button_clicked', false, 200, 'admin_dashboard');
		this.setState({ errorMessage: "" });
		this.props.closeCreateAdminModal();
		this.props.setLoading(true);
		try {
			const response = await createNewAdmin(payload);
			if (response?.statusCode === 200) {
				analyticsClickEvent('admin_created_successfully', '');
				frontEndLogs('admin_created_successfully', false, 200, 'admin_dashboard');

				this.resetForm();
				this.props.openResponseModal(response.message, true, "Admin Created Successfully");
			} else {
				frontEndLogs('admin_creation_failed', true, response?.statusCode || 400, 'admin_dashboard');
				this.props.openResponseModal(response?.message || "Something went wrong", false, "Admin Creation Failed");
			}
		} finally {
			this.props.setLoading(false);
		}
	};

	render() {
		const { showCreateAdminModal } = this.props;
		if (!showCreateAdminModal) {
			return null;
		}
		return (

			<div className="modal-overlay">
				<div className="admin-modal">

					<h2 className="admin-modal-title">
						Create New Admin
					</h2>

					<div className="field-group">
						<div className="label-container">
							<label htmlFor="adminFirstName" className="admin-label">
								First Name <span className="required-field">*</span>
							</label>
							{
								this.state.formData.firstName && !this.state.errors.firstName &&
								<span>
									<img src="images/tick-mark.svg" alt="tick icon for validation" className="validation-tickmark" />
								</span>
							}
						</div>

						<input
							id="adminFirstName"
							name="firstName"
							type="text"
							className="form-control admin-input"
							placeholder="Enter first name"
							value={this.state.formData.firstName}
							onChange={this.handleInputChange}
							onBlur={this.handleBlur}
						/>

						<div className="app-error-message">
							{this.state.errors.firstName}
						</div>
					</div>

					<div className="field-group">
						<div className="label-container">
							<label htmlFor="adminLastName" className="admin-label">
								Last Name <span className="required-field">*</span>
							</label>
							{
								this.state.formData.lastName && !this.state.errors.lastName &&
								<span>
									<img src="images/tick-mark.svg" alt="tick icon for validation" className="validation-tickmark" />
								</span>
							}
						</div>

						<input
							id="adminLastName"
							name="lastName"
							type="text"
							className="form-control admin-input"
							placeholder="Enter last name"
							value={this.state.formData.lastName}
							onChange={this.handleInputChange}
							onBlur={this.handleBlur}
						/>

						<div className="app-error-message">
							{this.state.errors.lastName}
						</div>
					</div>

					<div className="field-group">
						<div className="label-container">
							<label htmlFor="adminEmail" className="admin-label">
								Email <span className="required-field">*</span>
							</label>
							{
								this.state.formData.email && !this.state.errors.email &&
								<span>
									<img src="images/tick-mark.svg" alt="tick icon for validation" className="validation-tickmark" />
								</span>
							}
						</div>

						<input
							id="adminEmail"
							type="text"
							name="email"
							className="form-control admin-input"
							placeholder="Enter email"
							value={this.state.formData.email}
							onChange={this.handleInputChange}
							onBlur={this.handleBlur}
						/>
						<div className="app-error-message">
							{this.state.errors.email}
						</div>
					</div>

					<div className="field-group">
						<div className="label-container">
							<label htmlFor="adminMobileNumber" className="admin-label">
								Mobile Number <span className="required-field">*</span>
							</label>
							{
								this.state.formData.mobileNumber && !this.state.errors.mobileNumber &&
								<span>
									<img src="images/tick-mark.svg" alt="tick icon for validation" className="validation-tickmark" />
								</span>
							}
						</div>

						<input
							id="adminMobileNumber"
							name="mobileNumber"
							type="text"
							className="form-control admin-input"
							placeholder="Enter mobile number"
							value={this.state.formData.mobileNumber}
							onChange={this.handleInputChange}
							onBlur={this.handleBlur}
						/>
						<div className="app-error-message">
							{this.state.errors.mobileNumber}
						</div>
					</div>

					<div className="admin-modal-footer">
						<button
							type="button"
							className="btn cancel-btn"
							onClick={this.handleCloseModal}
						>
							Cancel
						</button>

						<button
							type="button"
							className="btn create-btn"
							disabled={!this.isCreateAdminFormValid()}
							onClick={this.handleCreateAdmin}
						>
							Create
						</button>
					</div>

				</div>
			</div>
		);
	}
}

CreateAdminModal.propTypes = {
	showCreateAdminModal: PropTypes.bool.isRequired,
	closeCreateAdminModal: PropTypes.func.isRequired,
	openResponseModal: PropTypes.func.isRequired,
	setLoading: PropTypes.func.isRequired
};
